import { createApp } from 'vue'
import App from './App.vue'
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// MDI Icons
import '@mdi/font/css/materialdesignicons.css';

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#0db5ee', // Custom primary color
        },
      },
      dark: {
        colors: {
          primary: '#0db5ee', // Custom primary color for dark theme
        },
      },
    },
  }
})
createApp(App).use(vuetify).mount('#app')
